import styled from 'styled-components';

import { AlertType } from './Alert';

export const Wrapper = styled.div<{ color: AlertType }>`
  width: 100%;
  height: auto;
  padding: 9px 0 0;
  border-radius: 2px;
  ${({ color }) =>
    color === AlertType.PRIMARY
      ? `background-color: rgba(128, 54, 229, 0.1);`
      : `background-color: rgba(254, 151, 57, 0.1);`}
  position: relative;
  text-align: center;
`;

export const Title = styled.span<{ color: AlertType }>`
  margin: 0 10px 3px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme, color }) =>
    color === AlertType.PRIMARY
      ? theme.palette.bluishPurple
      : theme.palette.fadedOrange};
`;

export const SubTitle = styled.span<{ color: AlertType }>`
  width: 95%;
  margin: 3px 10px 0;
  font-size: 12px;
  text-align: center;
  color: ${({ theme, color }) =>
    color === AlertType.PRIMARY
      ? theme.palette.bluishPurple
      : theme.palette.fadedOrange};
`;

export const Button = styled.button<{ color: AlertType }>`
  width: 100%;
  min-height: 33px;
  margin: 9px 0 0;
  border-radius: 2px;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: center;
  border: none;
  cursor: pointer;
  background-color: ${({ theme, color }) =>
    color === AlertType.PRIMARY
      ? theme.palette.bluishPurple
      : theme.palette.fadedOrange};
  :focus {
    outline: none;
  }
`;

export const ButtonText = styled.span<{ color: AlertType }>`
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  text-decoration: underline;
`;

export const ReadMoreWrapper = styled.span`
  position: relative;
  margin: 15px 10px 0 0;
  transition: all 0.5s;
`;
export const Description = styled.p<{ showFull: boolean }>`
  white-space: initial;
  max-height: ${({ showFull }) => (showFull ? '100vh' : '75px')};
  transition: all 0.7s;
`;

export const ReadMore = styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  right: 20px;
  bottom: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.coral};
`;
